import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["dropzone"];

  connect() {
    this.urlValue = this.data.get("url");
  }

  validateBucket() {
    fetch(this.urlValue)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.error_message) {
          this.handleStorageLimit(data.error_message);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        this.handleStorageLimit('An error occurred while checking storage limit.');
      });
  }

  handleStorageLimit(message) {
    alert(message);
    this.disableUploading();
  }

  disableUploading() {
    // Full screen frame dropzone
    if (this.element.classList.contains('full-screen-frame-widget-id')) {
      const dropzoneElement = document.getElementById('full-screen-frame-dropzone');
      // Destroy the Dropzone instance
      if (dropzoneElement.dropzone) {
        dropzoneElement.dropzone.disable();
        dropzoneElement.dropzone.destroy();
      }

      dropzoneElement.innerHTML = 'Uploading not allowed. Storage limit exceeded.';

      dropzoneElement.querySelectorAll('input[type="file"]').forEach(input => {
        input.disabled = true;
      });
    } else {
      this.element.innerHTML = 'Uploading not allowed. Storage limit exceeded.';
      // Disable any file input elements
      this.element.querySelectorAll('input[type="file"]').forEach(input => {
        input.disabled = true;
      });
    }
  }
}